import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

/**
 * Extracted from `AdminUsersPanel` (issue #626 — that component was 47 lines
 * over the `max-lines-per-function` budget). Pure markup for the #566
 * name/email correction dialog: `editTarget` / `editForm` / `editError` /
 * `editSaving` and the actual PATCH (`saveEdit`) all still live in
 * `AdminUsersPanel`. This component only renders the dialog and reports
 * field edits, cancel and save upward.
 */
export default function AdminEditUserDialog({
  editTarget,
  editForm,
  editError,
  editSaving,
  onOpenChange,
  onFieldChange,
  onCancel,
  onSave,
}) {
  return (
    <Dialog open={!!editTarget} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="admin-edit-dialog">
        <DialogHeader>
          <DialogTitle>Edit details{editTarget ? ` — ${editTarget.display_name}` : ""}</DialogTitle>
          <DialogDescription>
            Corrects the name and email on the account. Nobody is signed out, and the password
            stays what it was — their next password-reset email simply goes to the new address.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="min-w-0">
            <Label htmlFor="admin-edit-name">Name</Label>
            <Input
              id="admin-edit-name"
              value={editForm.display_name}
              onChange={(e) => onFieldChange("display_name", e.target.value)}
              className="mt-1"
              data-testid="admin-edit-name"
            />
          </div>
          <div className="min-w-0">
            <Label htmlFor="admin-edit-email">Email</Label>
            <Input
              id="admin-edit-email"
              type="email"
              value={editForm.email}
              onChange={(e) => onFieldChange("email", e.target.value)}
              className="mt-1"
              data-testid="admin-edit-email"
            />
          </div>
          {editError && (
            <p className="text-xs text-red-600" data-testid="admin-edit-error">{editError}</p>
          )}
        </div>
        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={editSaving}
            data-testid="admin-edit-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={editSaving}
            style={{ background: "#0B2E59" }}
            data-testid="admin-edit-save"
          >
            {editSaving ? "Saving…" : "Save changes"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
